import {
  Component, ChangeDetectionStrategy, Input, OnInit, ChangeDetectorRef, HostBinding, DestroyRef, inject,
} from '@angular/core'
import { NgControl } from '@angular/forms'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'

@Component({
  selector: 'kb-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
})
export class ErrorComponent implements OnInit {
  @Input() public validatorName?: string

  @HostBinding('class.kb-show')
  private show = true

  private destroyRef = inject(DestroyRef)
  public ngControl = inject(NgControl, { optional: true })
  private cdr = inject(ChangeDetectorRef)

  public ngOnInit(): void {
    if (!this.validatorName) {
      return
    }

    this.show = this.ngControl?.errors?.[this.validatorName] ?? false
    this.ngControl?.statusChanges?.pipe(
      takeUntilDestroyed(this.destroyRef),
    ).subscribe(() => {
      if (!this.validatorName) {
        return
      }
      this.show = this.ngControl?.errors?.[this.validatorName] ?? false
      this.cdr.markForCheck()
    })
  }
}
